import types from "./actionTypes";
import { dealWithRrdefs } from '../../undoredo/actions'


export const addRrdef = (payload, noUndoRedo) => (dispatch) => {

	if (noUndoRedo != true)
		dispatch(dealWithRrdefs(payload, 'add'))

	dispatch({
		type: types.ADD_ROUTING_RULE,
		payload,
	})
};

export const editRrdef = (payload, noUndoRedo) => (dispatch) => {

	if (noUndoRedo != true)
		dispatch(dealWithRrdefs(payload, 'edit'))

	dispatch({
		type: types.EDIT_ROUTING_RULE,
		payload,
	})
};


export const deleteRrdef = (payload, noUndoRedo) => (dispatch) => {

	if (noUndoRedo != true)
		dispatch(dealWithRrdefs(payload, 'delete'))

	dispatch({
		type: types.DELETE_ROUTING_RULE,
		payload,
	})
};

export const updateFullRoutingRules = (rrdefs) => ({
	type: types.UPDATE_FULL_ROUTING_RULES,
	payload: rrdefs
})

export const resetRoutingRules = (rrdefs) => ({
	type: types.RESET_ROUTING_RULES,
	payload: rrdefs
})